import React, { createContext, useState, useMemo, useCallback } from 'react';

export type HoverState = {
    originViz: string;
    xVal: number;
    seriesKey?: string;
};

export type SelectedState = {
    originViz: string;
    xVal: number;
    seriesKey: string;
};

export type VizContextOutputType = {
    clearSharedState: () => void;
    syncedHoverValue?: HoverState;
    setSyncedHoverValue: React.Dispatch<React.SetStateAction<HoverState | undefined>>;
    syncedSelectedValue?: SelectedState;
    setSyncedSelectedValue: React.Dispatch<React.SetStateAction<SelectedState | undefined>>;
    hasProvider?: boolean;
};

export const VizContext = createContext<VizContextOutputType | null>(null);

export const VizContextProvider = ({ children }: { children: React.ReactNode }) => {
    const [syncedHoverValue, setSyncedHoverValue] = useState<HoverState>();
    const [syncedSelectedValue, setSyncedSelectedValue] = useState<SelectedState>();

    const clearSharedState = useCallback(() => {
        setSyncedHoverValue(undefined);
        setSyncedSelectedValue(undefined);
    }, []);

    const props = useMemo(
        () => ({
            clearSharedState,
            syncedHoverValue,
            setSyncedHoverValue,
            syncedSelectedValue,
            setSyncedSelectedValue,
        }),
        [clearSharedState, syncedHoverValue, syncedSelectedValue]
    );

    return <VizContext.Provider value={props}>{children}</VizContext.Provider>;
};
